import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { CircularProgress } from "@material-ui/core";
import { getBackendUrl } from "../../config";
import logo from "../../assets/logo.png";
import logoDark from "../../assets/logo-black.png";

const defaultTicketsManagerWidth = 550;
const minTicketsManagerWidth = 404;
const maxTicketsManagerWidth = 700;

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		padding: "2px",
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
	},
	chatPapper: {
		display: "flex",
		height: "100%",
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		position: "relative",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexGrow: 1,
	},
	welcomeMsg: {
		background: theme.palette.tabHeaderBackground,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		padding: 24,
	},
	welcomeInner: {
		maxWidth: 520,
		width: "100%",
	},
	welcomeLogo: {
		marginBottom: 16,
		opacity: 0.9,
	},
	welcomeTitle: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: 8,
		color: theme.palette.text.primary,
	},
	welcomeSubtitle: {
		fontSize: 14,
		color: theme.palette.text.secondary,
		marginBottom: 24,
	},
	welcomeTips: {
		textAlign: "left",
		background: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)",
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 8,
		padding: "12px 16px",
		fontSize: 13,
		lineHeight: 1.7,
		color: theme.palette.text.primary,
	},
	welcomeTipsTitle: {
		fontWeight: 600,
		marginBottom: 6,
		fontSize: 12,
		textTransform: "uppercase",
		letterSpacing: 0.5,
		color: theme.palette.text.secondary,
	},
	welcomeKbd: {
		display: "inline-block",
		fontFamily: "monospace",
		background: theme.palette.type === "dark" ? "#222" : "#eaeaea",
		padding: "1px 6px",
		borderRadius: 4,
		fontSize: 12,
		marginRight: 4,
	},
	dragger: {
		width: "5px",
		cursor: "ew-resize",
		padding: "4px 0 0",
		borderTop: "1px solid #ddd",
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		zIndex: 100,
		backgroundColor: "#f4f7f9",
		userSelect: "none", // Evita a seleção de texto no elemento de redimensionamento
	},
	logo: {
		logo: theme.logo,
		content: "url(" + (theme.mode === "light" ? theme.calculatedLogoLight() : theme.calculatedLogoDark()) + ")"
	},
}));

const TicketsCustom = () => {
	const { user } = useContext(AuthContext);

	const classes = useStyles({ ticketsManagerWidth: user.defaultTicketsManagerWidth || defaultTicketsManagerWidth });

	const { ticketId } = useParams();

	const [ticketsManagerWidth, setTicketsManagerWidth] = useState(0);
	const ticketsManagerWidthRef = useRef(ticketsManagerWidth);

	useEffect(() => {
		if (user && user.defaultTicketsManagerWidth) {
			setTicketsManagerWidth(user.defaultTicketsManagerWidth);
		}
	}, [user]);

	// useEffect(() => {
	// 	if (ticketId && currentTicket.uuid === undefined) {
	// 		history.push("/tickets");
	// 	}
	// }, [ticketId, currentTicket.uuid, history]);

	const handleMouseDown = (e) => {
		document.addEventListener("mouseup", handleMouseUp, true);
		document.addEventListener("mousemove", handleMouseMove, true);
	};
	const handleSaveContact = async value => {
		if (value < 404)
			value = 404
		await api.put(`/users/toggleChangeWidht/${user.id}`, { defaultTicketsManagerWidth: value });

	}
	const handleMouseMove = useCallback(
		(e) => {
			const newWidth = e.clientX - document.body.offsetLeft;
			if (
				newWidth > minTicketsManagerWidth &&
				newWidth < maxTicketsManagerWidth
			) {
				ticketsManagerWidthRef.current = newWidth;
				setTicketsManagerWidth(newWidth);
			}
		},
		[]
	);

	const handleMouseUp = async () => {
		document.removeEventListener("mouseup", handleMouseUp, true);
		document.removeEventListener("mousemove", handleMouseMove, true);

		const newWidth = ticketsManagerWidthRef.current;

		if (newWidth !== ticketsManagerWidth) {
			await handleSaveContact(newWidth);
		}
	};

	return (
		<QueueSelectedProvider>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<div
						className={classes.contactsWrapper}
						style={{ width: ticketsManagerWidth }}
					>
						<TicketsManager />
						<div onMouseDown={e => handleMouseDown(e)} className={classes.dragger} />
					</div>
					<div className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								{/* <Suspense fallback={<CircularProgress />}> */}
								<Ticket />
								{/* </Suspense> */}
							</>
						) : (
							<Hidden only={["sm", "xs"]}>
								<Paper square variant="outlined" className={classes.welcomeMsg}>
									<div className={classes.welcomeInner}>
										<img className={`${classes.logo} ${classes.welcomeLogo}`} width="45%" alt="" />
										<div className={classes.welcomeTitle}>
											{i18n.t("chat.noTicketMessage")}
										</div>
										<div className={classes.welcomeSubtitle}>
											Selecione uma conversa na lista ao lado para começar o atendimento.
										</div>
										<div className={classes.welcomeTips}>
											<div className={classes.welcomeTipsTitle}>Atalhos úteis</div>
											<div>
												<span className={classes.welcomeKbd}>⏱</span>
												Badge âmbar nos tickets indica que estão parados há mais de 30 minutos.
											</div>
											<div>
												<span className={classes.welcomeKbd}>📎</span>
												Use o ícone de cópia no painel de contato para copiar o telefone.
											</div>
											<div>
												<span className={classes.welcomeKbd}>🔗</span>
												Em Integrações, configure o n8n para automatizar respostas e tags.
											</div>
										</div>
									</div>
								</Paper>
							</Hidden>
						)}
					</div>
				</div>
			</div>
		</QueueSelectedProvider>
	);
};

export default TicketsCustom;